export class BlueprintResponseV2 {
}
